import { ColorX } from "../../../../STATIC";

let dark = {
  btn: {
    width: "50%"
  },
  btnBar: {
    width: "auto"
  },
  btnText: {
    fontFamily: "Arial",
  },  
  cell: (size) => ({
    height: size,
    minHeight: size,
    maxHeight: size,
    overflow: "hidden",
    width: size,
    minWidth: size,
    maxWidth: size,
    padding: 0,
    margin: 0,
    borderRadius: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    color: ColorX.CSS("dmWhite")
  }),
  cellSat: {
    backgroundColor: ColorX.CSS("pureBlue", 0.2)
  },
  cellSun: {
    backgroundColor: ColorX.CSS("pureRed", 0.2)
  },
  cellText: (size) => ({
    color: ColorX.CSS("dmWhite", 0.5),
    fontSize: Math.max(Math.round(size * 0.35), 12),
    textAlign: "center",
    fontFamily: "Arial"
  }),
  cellTextNotInMonth: {
    color: ColorX.CSS("dmWhite", 0.2)
  },
  cellTextNotValid: {
    color: ColorX.CSS("dmWhite", 0.2)
  },
  cellTextSat: {
    color: ColorX.CSS("bgBlue")
  },
  cellTextSun: {
    color: ColorX.CSS("bgRed"),
    bold: true
  },
  cellTextToday: (size) => ({
    fontSize: Math.max(Math.round(size * 0.5), 12),
    fontWeight: "bold"
  }),
  cellWeek: (size) => ({
    borderWidth: 0,
    borderBottomColor: ColorX.CSS("dmWhite", 0.5),
    borderBottomWidth: 1,
    borderStyle: "solid",
    borderTopColor: ColorX.CSS("dmWhite", 0.5),
    borderTopWidth: 1,
    width: size,
    height: size * 0.75
  }),
  coreMonthBtn: (size) => ({
    width: size * 3,
    height: Math.round(size * 0.9)
  }),
  coreMonthBtnText: (size) => ({
    color: ColorX.CSS("dmWhite"),
    textAlign: "center",
    fontSize: Math.round(size * 0.43),
    fontFamily: "Arial"
  }),
  coreMonthBtnTextDisabled: (size) => ({
    color: ColorX.CSS("dmWhite", 0.5),
    textAlign: "center",
    fontFamily: "Arial"
  }),
  coreMonthBtnTextInSelect: (size) => ({
    color: ColorX.CSS("cmBlue"),
    fontWeight: "bold",
    textAlign: "center",
    fontSize: Math.round(size * 0.5),
    fontFamily: "Arial"
  }),
  coreYearBtn:  (size) => ({
    width: size * 2.5,
    height: Math.round(size * 1.1),
    color: ColorX.CSS("dmWhite"),
  }),
  coreYearBtnText: (size) => ({
    color: ColorX.CSS("dmWhite"),
    textAlign: "center",
    fontSize: Math.round(size * 0.43),
    fontFamily: "Arial"
  }),
  coreYearBtnTextDisabled: (size) => ({
    color: ColorX.CSS("dmWhite", 0.5),
    textAlign: "center",
    fontFamily: "Arial"
  }),
  coreYearBtnTextInSelect: (size) => ({
    color: ColorX.CSS("dmWhite"),
    fontWeight: "bold",
    textAlign: "center",
    fontSize: Math.round(size * 0.5),
    fontFamily: "Arial"
  }),
  disMonthTextView: (size) => ({
    padding: 0,
    flex: 1,
    height: size * 1,
  }),
  disText: (size) => ({
    color: ColorX.CSS("dmWhite"),
    fontWeight: "bold",
    fontFamily: "Arial",
    textAlign: "center",
    fontSize: Math.round(size / 2.3),
  }),
  disYearTextView: (size) => ({
    padding: 0,
    width: size * 1.7,
    height: size * 1,
    maxWidth: size * 1.7,
    minWidth: size * 1.7
  }),
  highlightStyle: {
    height: "100%"
  },
  highlightStyleDate: (size) => ({
    backgroundColor: ColorX.CSS("dmWhite", 0.5),
    borderBottomLeftRadius: Math.round(size * 0.75),
    borderBottomRightRadius: Math.round(size * 0.75),
    borderTopLeftRadius: Math.round(size * 0.75),
    borderTopRightRadius: Math.round(size * 0.75),
    height: Math.round(size * 0.8),
    width: Math.round(size * 0.8),
    marginLeft: Math.round(size * 0.1),
    marginRight: Math.round(size * 0.1),
    marginVertical: Math.round(size * 0.1),
    
  }),
  highlightStyleEnd: (size) => ({
    backgroundColor: ColorX.CSS("dmWhite", 0.5),
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: Math.round(size * 0.75),
    borderTopLeftRadius: 0,
    borderTopRightRadius: Math.round(size * 0.75),
    height: Math.round(size * 0.8),
    width: Math.round(size * 1),
    marginLeft: 0,
    marginRight: Math.round(size * 0.05),
    marginVertical: Math.round(size * 0.1),
  }),
  highlightStyleIn: (size) => ({
    backgroundColor: ColorX.CSS("dmWhite", 0.5),
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    height: Math.round(size * 0.8),
    width: Math.round(size * 1),
    marginLeft: 0,
    marginRight: 0,
    marginVertical: Math.round(size * 0.1),
  }),
  highlightStyleStart: (size) => ({
    backgroundColor: ColorX.CSS("dmWhite", 0.5),
    borderBottomLeftRadius: Math.round(size * 0.75),
    borderBottomRightRadius: 0,
    borderTopLeftRadius: Math.round(size * 0.75),
    borderTopRightRadius: 0,
    height: Math.round(size * 0.8),
    marginLeft: Math.round(size * 0.05),
    marginRight: 0,
    marginVertical: Math.round(size * 0.1),
    width: Math.round(size * 1),
  }),
  highlightStyleText: {
    color: ColorX.CSS("dmWhite"),
  },
  mainContainer: (size) => ({
    backgroundColor: ColorX.CSS("dmBgDark"),
    borderBottomLeftRadius: Math.round(size * 0.3),
    borderBottomRightRadius: Math.round(size * 0.3),
    borderTopLeftRadius: Math.round(size * 0.3),
    borderTopRightRadius: Math.round(size * 0.3),
    overflow: "hidden",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: ColorX.CSS("dmWhite"),
  }),
  innerContainer: (size) => ({
    padding: Math.round(size * 0.05),
  }),
  shiftBtn: (size) => ({
    alignItems: "center",
    height: size * 1,
    justifyContent: "center",
    overflow: "hidden",
    padding: 0,
    width: Math.round(size * 0.5),
    minWidth: Math.round(size * 0.5),
    maxWidth: Math.round(size * 0.5),
  }),
  shiftYearBtn: (size) => ({
    alignItems: "center",
    height: "100%",
    justifyContent: "center",
    overflow: "hidden",
    padding: 0,
    width: Math.round(size * 0.5),
    minWidth: Math.round(size * 0.5),
    maxWidth: Math.round(size * 0.5),
  }),
  shiftIcon: {
    color: ColorX.CSS("dmWhite")
  },
  shiftIconDisabled: {
    color: ColorX.CSS("grey", 0.5)
  },
  topBar: {
    
  },
  thisWeekBar: {
    bgColor: ColorX.CSS("pureGreen", 0.2) 
  },
  notThisWeekBar: {

  }
};

export default dark;